<template>
  <div>
    <dashboard-alert
      v-for="(alert, index) in alerts"
      :key="index"
      :variant="alert.color.toLowerCase()"
      :title="alert.title"
      :description="alert.text"
    />
    <p v-if="loading">
      <b-spinner label="Loading..." />
    </p>
    <div v-if="description && !loading">
      <p v-html="description" />
    </div>
  </div>
</template>

<script>
import DescriptionApis from '@/services/apis/description'
import DashboardAlert from '../dashboard/dashboardAlert.vue'

const description = new DescriptionApis()
export default {
  components: {
    DashboardAlert,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      description: null,
      loading: false,
      alerts: [],
    }
  },
  watch: {
    '$store.state.appConfig.layout.isRTL': {
      handler() {
        this.alerts = []
        this.description = null
        this.getDescriptions()
      },
    },
  },
  async created() {
    await this.getDescriptions()
  },
  methods: {
    async getDescriptions() {
      this.loading = true

      try {
        const { name } = this.$props
        const res = await description.get({ name })

        try {
          const parsedValue = JSON.parse(res.data.results.value)
          this.description = parsedValue.value
          this.alerts = parsedValue.alertTexts
        } catch {
          this.description = res.data.results.value
          this.alerts = []
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Add your styles here */
</style>
